var exports = {
  "kL": "x234b8571--13109f--container",
  "b0": "x234b8571--13109f--ticker",
  "$I": "x234b8571--13109f--ticker--static",
  "xG": "x234b8571--13109f--ticker--infinite",
  "fj": "x234b8571--13109f--tickerInifnite",
};

module.exports = exports;
